@if (view$ | async; as view) {
    @if (view.noActivatedChildren) {
        <div class="container-fluid pb-3">
            <div class="w-100 d-flex justify-content-end mt-0">
                <div class="btn-group d-flex my-3">
                    <button
                        class="btn btn-outline-primary"
                        [disabled]="view.eventAlarmTemplates.loading"
                        (click)="selectTemplate(view.eventAlarmTemplates)">
                        {{ 'event-alarms_create-event-alarm' | translate }}
                    </button>
                    <button
                        type="button"
                        class="btn mx-1 btn-outline-primary"
                        (click)="setViewMode('card')">
                        <i
                            class="bi bi-border-all"
                            style="vertical-align: middle; display: inline-flex"></i>
                    </button>
                    <button
                        type="button"
                        class="btn btn-outline-primary"
                        (click)="setViewMode('table')">
                        <i
                            class="bi bi-list-ul"
                            style="vertical-align: middle; display: inline-flex"></i>
                    </button>
                </div>
            </div>
            @if (viewMode() === 'table') {
                <app-event-alarms-table
                    [eventAlarms]="view.eventAlarms"
                    (deleteEventAlarm)="deleteEventAlarm(view.buildingNo, $event)"
                    (duplicateAlarm)="duplicateEventAlarm(view.buildingNo, $event)"
                    (editAlarm)="editEventAlarm($event)" />
            } @else {
                <app-event-alarms-card-view
                    (deleteEventAlarm)="deleteEventAlarm(view.buildingNo, $event)"
                    [eventAlarms]="view.eventAlarms"
                    (duplicateAlarm)="duplicateEventAlarm(view.buildingNo, $event)"
                    [buildingNo]="view.buildingNo"
                    (editAlarm)="editEventAlarm($event)" />
            }
        </div>
    }
}
<router-outlet />
